module.exports = __webpack_public_path__ + "static/media/afflix-icon.30d18ffe.svg";